import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'tmt-ui-kit';
import { connect } from 'react-redux';

import withTrip from '../withTrip';
import { convertPriceDetail as convert } from '~/utils/price';
import { calculateTripPrice } from '~/utils/helpers';
import { actions as tripActions } from '~/redux/reducers/trip';

const priceConverter = (currency, rates) => price => convert(price, currency, rates);

const enhance = connect(
  state => ({
    sessionData: state.session.data,
    rates: state.info.exchangeRates,
    quantity: state.trip.nonTripQuantity,
  }), {
    onChangeQuantity: tripActions.changeNonTripQuantity,
  }
);

class CarRentalQuanlitySelector extends Component {
  render() {
    const { trip, sessionData, rates, quantity } = this.props;
    let unitLabel = 'car';
    if (trip.tags.includes('van')) unitLabel = 'van';
    else if (trip.is_ferry_transfer || (trip.tags || []).includes('joined_transfer')) unitLabel = 'person';
    const maxQuantity = trip.max_travelers;
    const { currency } = sessionData;
    const convertPrice = priceConverter(currency, rates);
    const prices = trip.full_prices.map(p => p.seasoned);
    const price = calculateTripPrice(prices, quantity, 0, 0);
    const pricePerItem = price / quantity;
    return (
      <Form.QuantityInput
        label="Quantity"
        max={maxQuantity}
        min={1}
        onChangeCounter={this.props.onChangeQuantity}
        subLabel={`${convertPrice(pricePerItem)} ${currency} per ${unitLabel}`}
        value={quantity}
      />
    );
  }
}

CarRentalQuanlitySelector.propTypes = {
  trip: PropTypes.object,
  sessionData: PropTypes.object,
  rates: PropTypes.object,
  onChangeQuantity: PropTypes.func,
  quantity: PropTypes.number,
};

export default withTrip(enhance(CarRentalQuanlitySelector));
